import { all, call, put, takeLatest } from 'redux-saga/effects'
import { ApiClient } from '../../../utilities/api';
import ApiPath from '../../../constants/apiPath';
import { toast } from 'react-toastify';
import { setaddSupport, onErrorStopLoad,setAllResouces, setGetAllResources, setCategoryData, setSingleCategoryInfo, setArticleInfo } from '../../slices/support';


// Worker saga will be fired on USER_FETCH_REQUESTED actions

function* addSupportForm(action) {
  try {
    const resp = yield call(ApiClient.post, action.url = ApiPath.SupportApiPath.ADD_SUPPORT, action.payload = action.payload);
    if (resp.status) {
      yield put(setaddSupport(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setaddSupport({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}


function* getAllResouces(action) {
  try {
    var dataToSend = { ...action.payload }
    delete dataToSend.cb
    const resp = yield call(ApiClient.get, action.url = ApiPath.SupportApiPath.GET_ALL_RESOURCES, action.params = { params: dataToSend });
    if (resp.status) {
      yield put(setGetAllResources(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      // toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setGetAllResources({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}

function* categoryData(action) {
  var dataToSend = { ...action.payload }
  delete dataToSend.cb
  delete dataToSend.id
  try {
    const resp = yield call(ApiClient.get, action.url = `${ApiPath.SupportApiPath.CATEGORY_DATA}/${action.payload.id}`,action.params = { params: dataToSend });
    if (resp.status) {
      yield put(setCategoryData(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      // toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setCategoryData({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}

function* articleInfo(action) {
  var dataToSend = { ...action.payload }
  delete dataToSend.cb
  delete dataToSend.id
  try {
    const resp = yield call(ApiClient.get, action.url = `${ApiPath.SupportApiPath.SINGLE_CATEGORY_INFO}/${action.payload.id}`,action.params = { params: dataToSend });
    if (resp.status) {
      yield put(setArticleInfo(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      // toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setArticleInfo({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}



function* userSupportSaga() {
  yield all([
    takeLatest('support/addSupport', addSupportForm),
    takeLatest('support/getAllResources', getAllResouces),
    takeLatest('support/categoryData', categoryData),
    takeLatest('support/articleInfo', articleInfo),
  ])
}

export default userSupportSaga;